import { createIcon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var Warning = createIcon({
  displayName: 'Warning',
  viewBox: '0 0 24 24',
  path: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0174 16.9414C13.0174 17.5015 12.5609 17.956 11.9983 17.956C11.4358 17.956 10.9792 17.5015 10.9792 16.9414C10.9792 16.3813 11.4358 15.9267 11.9983 15.9267C12.5609 15.9267 13.0174 16.3813 13.0174 16.9414ZM12.5079 14.9121H11.4888L10.9792 9.83878H13.0174L12.5079 14.9121ZM11.9983 4.82638L20.4568 19.9853H3.53985L11.9983 4.82638ZM11.9983 3C11.8883 3.01319 11.7965 3.08422 11.7548 3.18061L2.05197 20.5536C1.91949 20.7971 2.05197 21 2.31694 21H21.6797C21.9651 21 22.0772 20.7971 21.9447 20.5536L12.2429 3.18264C12.2001 3.08422 12.1084 3.01319 11.9993 3H11.9983Z",
    fill: "currentColor"
  })
});
//# sourceMappingURL=Warning.js.map